/**
 * 用户收益服务
 */

import { apiClient } from './apiClient';

export class UserProfitService {
  /**
   * 获取每日收益数据
   */
  async getDailyProfits(startDate?: string, endDate?: string): Promise<any> {
    const response = await apiClient.get<any>('/daily-profits', {
      params: {
        startDate,
        endDate,
        _t: Date.now(),
        _v: '4.0.0',
      },
    });

    if (!response.success) {
      throw new Error(response.message || '获取每日收益数据失败');
    }

    return response.data;
  }

  /**
   * 获取用户收益统计
   */
  async getUserProfitStats(): Promise<any> {
    const response = await apiClient.get<any>('/user-profit/stats');

    if (!response.success) {
      throw new Error(response.message || '获取用户收益统计失败');
    }

    return response.data;
  }

  /**
   * 获取用户历史收益记录
   */
  async getUserProfitHistory(days: number = 30): Promise<any> {
    const response = await apiClient.get<any>(`/user-profit/history?days=${days}`);

    if (!response.success) {
      throw new Error(response.message || '获取用户历史收益记录失败');
    }

    return response.data;
  }

  /**
   * 获取资金池统计信息
   */
  async getFundPoolStats(): Promise<any> {
    const response = await apiClient.get<any>('/user-profit/fund-pool');

    if (!response.success) {
      throw new Error(response.message || '获取资金池统计信息失败');
    }

    return response.data;
  }
}

export const userProfitService = new UserProfitService();
